module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/schemes/schemes-menu/schemes-menu.component.css
// module id = ./src/app/schemes/schemes-menu/schemes-menu.component.css
// module chunks = main